import React from 'react'
import './InsRadioSearch.scss'

const InsRadioSearch = ({ 
  value,
  label,
  name,
  checked,
  onChange
}) => (
  <div className="radio-button-container-dark">
    <div className="radio-button">
      <input
        type="radio" 
        id={name}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={name}>
        <span>{label}</span>
      </label>
    </div>
  </div>
)

export default InsRadioSearch
